import { useQuery } from '@tanstack/react-query';

import AnalyticsRequester, { type ApiMetabaseEmbeddedRequest } from '@cobliteam/api-lib/src/dashboard/analytics';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const analyticsRequester = new AnalyticsRequester({
  host: env.apiHost,
});

const QUERY_KEY = 'ANALYTICS';
const useAnalytics = () => {
  const getFromMetabaseEmbeddedDashboardApi = (dashboardId: number) =>
    useQuery<string>({
      queryKey: [QUERY_KEY, dashboardId],
      queryFn: () => analyticsRequester.getFromMetabaseEmbeddedDashboardApi(dashboardId),
      staleTime: 1000 * 60 * 60 * 12, // 12 hour
      gcTime: 1000 * 60 * 60 * 12, // 12 hour
    });

  const getFromMetabaseQueryParams = (dashboardId: number, request: ApiMetabaseEmbeddedRequest) =>
    useQuery<string>({
      queryKey: [QUERY_KEY, dashboardId, request],
      queryFn: () => analyticsRequester.getFromMetabaseQueryParams(request),
    });

  return {
    getFromMetabaseEmbeddedDashboardApi,
    getFromMetabaseQueryParams,
  };
};

export default useAnalytics;
